<template>
    <div>
        <el-card>
            <div slot="header">
			    <span class="top_title">销售单</span>
		    </div>
            <div>
                <div class="searchItem">
                    <div class="search">
                        <span class="searchtips">发货时间:</span>
                        <el-date-picker
                            v-model="searchDate.dateRan"
                            type="daterange"
                            :picker-options="pickerOptions"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 230px"
                            :editable="false"
                            value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </div>
                    <div class="search">
                        <span class="searchtips">销售员:</span>
                        <el-input
                            v-model="searchDate.saler"
                            placeholder="请输入销售员名称"
                            style="width: 160px"
                        />
                    </div>
                    <div class="search">
                        <span class="searchtips">商品名称:</span>
                        <el-input
                            v-model="searchDate.name"
                            placeholder="请输入商品名称"
                            style="width: 160px"
                        />
                    </div>
                    <div class="search">
                        <span class="searchtips">订单号:</span>
                        <el-input
                            v-model="searchDate.onumber"
                            placeholder="请输入订单号"
                            style="width: 160px"
                        />
                    </div>
                    <div style="padding-right:10px">
                        <Customer :orderForm="searchDate" :hideStar='true'></Customer>
                    </div>
                    <div class="search">
                        <span class="searchtips">颜色:</span>
                        <el-input
                            v-model="searchDate.color"
                            clearable
                            style="width: 160px"
                            placeholder="请输入颜色"
                        />
                    </div>
                    <div class="search">
                        <span class="searchtips">尺码:</span>
                        <el-input
                            v-model="searchDate.size"
                            clearable
                            style="width: 160px"
                            placeholder="请输入尺码"
                        />
                    </div>
                    <div class="search">
                        <span class="searchtips">备注:</span>
                        <el-input
                            v-model="searchDate.remark"
                            clearable
                            style="width: 160px"
                            placeholder="请输入备注信息"
                        />
                    </div>
                    <div class="search">
                        <el-button type="primary" icon="el-icon-search" @click="searchOrder()">查询</el-button>
                    </div>
                    <div class="search">
                        <el-button
                            type="primary"
                            icon="el-icon-printer"
                            @click="print"
                            v-if="$common.checkWindowsEnv()"
                            >打印</el-button>
                        <el-button
                            type="primary"
                            icon="el-icon-document"
                            @click="changePdf"
                        >导出</el-button>
                    </div>
                </div>
                <el-row class="whole">
                    <el-col :span="8" class="wholeitem">
                        <div>销售单数</div>
                        <div>{{ total }}</div>
                    </el-col>
                    <el-col :span="8" class="wholeitem">
                        <div>销售数量</div>
                        <div>{{ totalUnit }}</div>
                    </el-col>
                    <el-col :span="8" class="wholeitem">
                        <div>销售商品金额(元)</div>
                        <div>{{ totalPrice }}</div>
                    </el-col>
                </el-row>
                <el-table
                    :data="tableData"
                    v-loading="loading"
                    @selection-change="handleSelectionChange"
                    style="
                        width: 100%;
                        margin-top: 20px;
                        margin-bottom: 20px;
                    "
                    border
                >
                    <el-table-column
                        align='center'
                        type="selection"
                        width="40px">
                    </el-table-column>
                    <el-table-column label="操作" align='center' width="80" v-if="$common.hasLimits('orderSendItemDetail')">
                        <template  slot-scope="props">
                            <el-button type="text" @click="showDetail(props.row)">详细</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sdate" label="发货时间" width="180">
                        <template #header>
                            {{'发货时间'}}
                            <el-button circle icon="el-icon-top" size="mini" v-if="searchDate.column=='sdate'&&searchDate.order==true" type="primary" @click="setSort('sdate',true)"></el-button>
                            <el-button circle icon="el-icon-top" size="mini" v-else @click="setSort('sdate',true)"></el-button>
                            <el-button circle icon="el-icon-bottom" size="mini" v-if="searchDate.column=='sdate'&&searchDate.order==false" type="primary" @click="setSort('sdate',false)"></el-button>
                            <el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort('sdate',false)"></el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="customer" label="客户" min-width="180">
                    </el-table-column>
                    <el-table-column prop="cerator" label="销售员" min-width="180">
                    </el-table-column>
                    <el-table-column prop="sumUnit" label="发货数" min-width="180">
                    </el-table-column>
                    <el-table-column prop="sumCancelUnit" label="退货数" min-width="180">
                    </el-table-column>
                    <el-table-column prop="sumPrice" label="金额(元)" min-width="180">
                    </el-table-column>
                    <el-table-column label="备注" show-overflow-tooltip min-width="180">
                        <template slot-scope="{row}">
                            <div class="uni_ellipsis">{{row.remark}}</div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    style="text-align: right"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[20, 50, 120, 250]"
                    :page-size="cp_pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    :pager-count="5"
                >
                </el-pagination>
            </div>
            <ReportOrder ref="roder"></ReportOrder>
            <edit-share ref="share"></edit-share>
        </el-card>
    </div>
</template>

<script>
import Customer from '@/components/customer.vue';
import ReportOrder from '../../components/printshare/reportorder'
import editShare from '../../components/printshare/edit_share';
export default {
    components: { Customer,ReportOrder,editShare },
    data() {
        return {
            loading:false,
            searchDate: {
                dateRan: "",
                name: "",
                saler:"",
                cid:"",
                remark:"",
                onumber:"",
                color:"",
                size:"",
            },
            pickerOptions: {shortcuts:this.$common.initPickerOptions()},
            currentPage: 1,
            cp_pagesize: 20,
            total: 100,
            totalPrice: 0,
            totalUnit: 0,
            tableData: [],
            searchObj:{},
            multipleSelection: [],
        };
    },
    created() {
        this.tableData = [];
        this.searchObj = {
            page: 1,
            limit: this.cp_pagesize,
        };
        this.currentPage = 1;
        this.getListSend();
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        print() {
            if(this.multipleSelection.length==0){
                this.$common.error("没有选择销售单");
            }else{
                let arr = [];
                this.multipleSelection.forEach(e=>{
                    arr.push(e.id);
                })
                this.$nextTick(()=>{
                    this.$refs.roder.extraOpen(1,arr);
                })
            }
        },
        changePdf(){
            if(this.multipleSelection.length==0){
                this.$common.error("没有选择销售单");
            }else{
                let arr = [];
                this.multipleSelection.forEach(e=>{
                    arr.push(e.id);
                })
                this.$nextTick(()=>{
                    this.$refs.share.openList(arr,1);
                })
            }
        },
        searchOrder(){
            this.searchObj = {
                page: 1,
                limit: this.cp_pagesize,
            }
            this.currentPage = 1;
            if(this.searchDate.dateRan&&this.searchDate.dateRan.length>=2){
                this.searchObj.start = this.searchDate.dateRan[0];
                this.searchObj.end = this.searchDate.dateRan[1];
            }
            if(this.searchDate.name){
                this.searchObj.prod = this.searchDate.name;
            }
            if(this.searchDate.saler){
                this.searchObj.saler = this.searchDate.saler;
            }
            if(this.searchDate.cid>0){
                this.searchObj.cid = this.searchDate.cid;
            }
            if(this.searchDate.color){
                this.searchObj.color = this.searchDate.color;
            }
            if(this.searchDate.size){
                this.searchObj.size = this.searchDate.size;
            }
            if(this.searchDate.remark){
                this.searchObj.remark = this.searchDate.remark;
            }
            if(this.searchDate.onumber){
                this.searchObj.onumber = this.searchDate.onumber;
            }
            this.sortTime();
        },
        setSort(column,order){
            if(this.searchDate.column==column&&this.searchDate.order==order){
                this.searchDate.column = '';
                this.searchDate.order = '';
            }else{
                this.searchDate.column = column;
                this.searchDate.order = order;
            }
            this.sortTime();
        },
        sortTime(){
            if(this.searchDate.column){
                this.searchObj.column = this.searchDate.column;
                this.searchObj.order = this.searchDate.order?'asc':'desc';
            }else{
                delete this.searchObj.column;
                delete this.searchObj.order;
            }
            this.getListSend();
        },
        handleSizeChange(val) {
            this.cp_pagesize = val;
            this.searchOrder();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.searchObj.page = val;
            this.getListSend();
        },
        getListSend() {
            this.loading = true;
            this.$api.listSend(this.searchObj).then((res) => {
                if (res.data.code == 1) {
                    this.tableData = [];
                    let info = res.data.data;
                    this.total = info.count;
                    this.totalPrice = info.sumPrice;
                    this.totalUnit = this.$common.changeNumDesc(info,'sumAmount','sumParts','sumUnit');
                    info.data.forEach((e) => {
                        let obj = {
                            id:e.id,
                            customer: e.customer.name,
                            cid:e.customer.id,
                            cerator: e.creator,
                            sdate: e.sdate,
                            remark: e.remark,
                            sumUnit:this.$common.changeNumDesc(e,'sumAmount','sumParts','sumUnit'),
                            sumCancelUnit:this.$common.changeNumDesc(e,'sumCancelAmount','sumCancelParts','sumCancelUnit'),
                            sumPrice:e.sumPrice,
                        };
                        this.tableData.push(obj);
                    });
                    this.loading = false;
                }
            });
        },
        showDetail:function(val){
            this.$router.push({
                path:'/sendDetail',
                query:{cid:val.cid,customer:val.customer,time:val.sdate},
            })
        },
    },
};
</script>

<style lang='scss' scoped>
.whole {
    margin-top: 20px;
    border: 1px solid #adb0b3;
    
    .wholeitem {
        padding: 12px 0;
        text-align: center;
        border-right: 1px solid #adb0b3;
        line-height: 24px;
    }
    .wholeitem:last-child {
        border-right: none;
    }
}
</style>
